import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import {
  Button,
  CardBody,
  IconButton,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai"
import { useQuery } from "@apollo/client"
import {
  GETALLAGENTS,
  GETALLFUNDSREQUEST,
  GETALLFUNDSREQUESTPENDING,
  GETBALANCEOFUSERS,
  GETUSERFUNDDETAILS,
  GETCOMPANYSTAFF,
} from "../../../GraphQl/queries"
import { AgentType, FundsType } from "../accountfunding"
import { ToastContainer, toast } from "react-toastify"
import { BASEURL, DEFAULTPRIMARYCOLOR } from "../../../util"
import { DASHBOARD_USERTYPE, parameter_type } from "../../../types/role"
import moment from "moment"
import { BiPlus, BiSolidEyedropper, BiTrash } from "react-icons/bi"
import { CustomModal } from "../../../components"
import { SubmitHandler, useForm } from "react-hook-form"
import { UserType } from "../../../types/user"
import { useLazyQuery } from "@apollo/client"
import { FaRegEye } from "react-icons/fa"
import CashLimit from "./cashlimit"
import { balanceDummyData, fundDummyRequest } from "../../../util/dummy"
import GeneralPagination from "../../../components/paginations/GeneralPagination"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import WhitePaginateComponent from "../../../components/paginations/whiteBackgroundPagination"
import { DriverModal } from "../../../components/modal/DriverModal"
import Otp from "../../../components/modal/enterOtpModal"

type BalanceType = {
  name: string
  balance: number
  funded_amount: number
  funded_by: string
  record_id: string
  record_type: string
}

type FormType = {
  amount: number
}

type InsurerCompany = {
  name: string
}

type RolePermission = {
  amount: number
  cash_limit: number
  insurer_company: InsurerCompany
  datecreated: string
  funded_by_company: string
  intermediary_id: string
  usertype: string
  user_id: string
}

type GetUserFundDetailsData = {
  intermediary_sub_agent_balance: RolePermission[]
}

type GetUserFundDetailsVariables = {
  id: string // Assuming UUID is represented as a string
}

const FundingApproval = () => {
  const [submitting, setSubmitting] = useState(false)
  const [searchRequestText, setRequestText] = useState("")
  const [searchBalanceText, setBalanceText] = useState("")
  const [activePage, setActivePage] = useState(1)
  const [showCashModal, setCashModal] = useState(false)
  const [showmoreModal, setMoreModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState("")
  const [action, Setaction] = useState("")
  const [selectedRow, setSelectedRow] = useState({
    parameter_id: "",
    parameter_type: "",
    funded_company: "",
    amount: 0
  })
  const [selectedItem, setSelectedItem] = useState<FundsType | null>(null)
  const [openOtp, setOpenOtp] = useState(false)

  const [activePage2, setActivePage2] = useState(1)
  const PAGE_SIZE = 10

  const {
    companyId,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  

 

 
 

  const {
    register,
    reset,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormType>({
    defaultValues: {
      amount: 0, // leave this blank or a safe fallback
    },
  });
  
  useEffect(() => {
    if (selectedRow) {
      reset({
        amount: selectedRow.amount,
      });
    }
  }, [selectedRow, reset]);
  

  const [
    getBalanceDetails,
    { data: balancedetails, loading: loadingDetails, refetch },
  ] = useLazyQuery<GetUserFundDetailsData, GetUserFundDetailsVariables>(
    GETUSERFUNDDETAILS,
    {
      variables: {
        id: selectedUser,
      },
    }
  )

  const {
    data: balances,
    loading: loadingBalances,
    refetch: refetchBalance,
  } = useQuery<{
    view_user_broker_balances: BalanceType[]
  }>(GETBALANCEOFUSERS, {
    variables: {
      id: companyId,
    },
  })
  // console.log(balances)

  const {
    data: funds,
    loading: loadingFunds,
    refetch: refchFunds,
  } = useQuery<{
    view_fund_account_details: FundsType[]
  }>(GETALLFUNDSREQUESTPENDING, {
    variables: {
      company_id: companyId,
    },
  })

  // console.log(funds)

  const handleSearch = (e: any) => {
    setRequestText(e.target.value)
    setActivePage(1)
  }

  const handleBalanceSearch = (e: any) => {
    setBalanceText(e.target.value)
    setActivePage2(1)
  }

  const filterData = (filter: FundsType) => {
    const isTextMatch =
      filter?.company_role_name
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.agent
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.branch_name
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.division_name
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.role_balance
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.company_role_name
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.company_staff_name
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.status
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.parameter_type
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase()) ||
      filter?.parameter_type
        ?.toLowerCase()
        ?.includes(searchRequestText?.toLowerCase())

    return isTextMatch
  }

  const filterBalance = (filter: BalanceType) => {
    const isTextMatch = filter?.name
      ?.toLowerCase()
      ?.includes(searchBalanceText?.toLowerCase())
    return isTextMatch
  }
  const [currentPageBa, setCurrentPageBa] = useState(0)
  const [itemsPerPage] = useState(10)

  useEffect(() => {
    if (searchBalanceText) {
      setCurrentPageBa(0)
    }
  }, [searchBalanceText])

  const totalBallanceItems =
    balances?.view_user_broker_balances?.filter(filterBalance)

  // const paginatedBalanceData = totalBallanceItems?.slice(
  //   startIndexBa,
  //   endIndexBa
  // )

  const endOffsetBa = currentPageBa + itemsPerPage
  const paginatedBalanceData = totalBallanceItems?.slice(
    currentPageBa,
    endOffsetBa
  )

  //------------------
  const [currentPageFa, setCurrentPageFa] = useState(0)

  useEffect(() => {
    if (searchRequestText) {
      setCurrentPageBa(0)
    }
  }, [searchRequestText])

  const totalFundItems = funds?.view_fund_account_details?.filter(filterData)


  const endOffsetFa = currentPageFa + itemsPerPage
  const paginatedFundsData = totalFundItems?.slice(currentPageFa, endOffsetFa)
  // console.log("paginatedFundsData", paginatedFundsData)

  const handleApprove = async (item: FundsType, response: string) => {
    const payload = {
      request_id: item?.funds_request_id,
      parameter_type: item?.parameter_type,
      parameter_id: item?.parameter_id,
      funded_by: item?.funded_company_id,
      previous_balance:
        item?.parameter_type === parameter_type.agent_id
          ? item?.agent_balance ?? "0"
          : item?.parameter_type === parameter_type.staff_id
          ? item?.staff_balance ?? "0"
          : item?.parameter_type === parameter_type?.branch_id
          ? item?.branch_balance ?? "0"
          : item?.parameter_type === parameter_type?.division_id
          ? item?.division_balance ?? "0"
          : item?.role_balance ?? "0",
      amount: item?.amount,
      response: response,
      usertype: DASHBOARD_USERTYPE.company,
    }
    setSubmitting(true)

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/approve-users-account-broker?broker_id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const req = await res.json()
      

      if (req.error === 403) {
        toast.error(req?.data)
      } else {
        toast.success(req?.message)
      }
    
      refchFunds()
      refetchBalance()
    } catch (error: any) {
      toast.error(error?.message ?? "An error occured")
    } finally {
      setSubmitting(false)
    }
  }

  const removeBalance = async (
    user_id: string,
    record_type: string,
    amount: number,
    funded_by: string
  ) => {
    try {
      const payload = {
        user_id: user_id,
        intermediary_id: companyId,
        funded_by: funded_by,
        record_type: record_type,
        amount: amount + "",
        usertype: DASHBOARD_USERTYPE.company,
      }
      console.log(payload)
      const res = await fetch(`${BASEURL}/remove-users-balance-broker`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })

      const req = await res.json()

      if (res.ok) {
        toast.success(req?.message)
        refetch()
      } else {
        toast.error(req?.detail ?? req?.message)
      }
    } catch (error: any) {
      toast.error(error?.message ?? "An error occured")
    }
  }

  const onUpdateClick = (
    parameter_type: string,
    parameter_id: string,
    funded_company: string,
    amount: number
  ) => {
    setSelectedRow({
      parameter_id,
      parameter_type,
      amount,
      funded_company,
    })
    Setaction("update")
    setOpenOtp(true)

  }

  const onSubmit: SubmitHandler<FormType> = async (data) => {
    try {
      let payload = {
        user_id: selectedRow?.parameter_id,
        parameter_type: selectedRow?.parameter_type,
        amount: Number(data?.amount),
        usertype: DASHBOARD_USERTYPE.company,
        funded_company: selectedRow.funded_company,
        client_type:
          selectedRow.parameter_type === "staff_id" ? "staff" : "agent",
      }

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/update-cash-limit-broker?broker_id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const req = await res.json()

      if (res.ok) {
        toast.success(req?.message ?? "Cash limit updated successfully")
        reset({
          amount: 0
        })
        refchFunds()

        refetchBalance()
        setCashModal(false)
      } else {
        toast.error(req?.detail ?? req?.message)
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to update cash limit")
    }
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser])

  useEffect(() => {
    if (selectedUser) {
      getBalanceDetails()
    }
  }, [selectedUser, getBalanceDetails])

  // console.log(paginatedFundsData)

  const companyRolePermissions =
    balancedetails?.intermediary_sub_agent_balance || []

  return (
    <>
      <CustomHeader title="Funding Request" />

      <DriverModal
        title="Enter Your PIN"
        open={openOtp}
        size={"xs"}
        focus="message"
        onClose={() => setOpenOtp(false)}
        children={
          <Otp
            onConfirm={() => {
              action === "approve"
                ? handleApprove(selectedItem!, "approve")
                : action === "disapprove"
                ? handleApprove(selectedItem!, "disapprove")
                : action === "update"
                ? setCashModal(true)
                : setOpenOtp(false)
            }}
            onClose={() => setOpenOtp(false)}
          />
        }
        // () => handleCreateSinglePaymentOrder(chosenId)
      />

      <CustomModal
        title="Update cash limit"
        onClose={() => setCashModal(false)}
        open={showCashModal}
        children={
          <>
            <ToastContainer />
            <form
              onSubmit={handleSubmit(onSubmit)}
              className=" rounded-lg overflow-hidden w-full"
            >
              <div className="">
                <div className="flex flex-col items-end justify-end">
                  <div className="w-full">
                    <div className="mb-6 flex flex-col gap-2">
                      <div className="w-full flex flex-col lg:items-center md:flex-col lg:flex-row my-1 gap-1">
                        <Typography
                          variant="h6"
                          color="blue-gray"
                          className="mb-2 font-semibold text-[14px] w-1/3"
                        >
                          Cash limit amount
                        </Typography>
                        <Input
                          className="w-full h-11 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 capitalize dark:focus:border-blue-500"
                          crossOrigin="anonymous"
                          label="Amount"
                          {...register("amount")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-end justify-end mt-5">
                <Button
                  type="submit"
                  size="sm"
                  style={{
                    background:
                      colors?.length! > 1
                        ? `${colors![0]?.toLowerCase()}`
                        : `${DEFAULTPRIMARYCOLOR}`,
                  }}
                  className="flex flex-row items-center font-normal"
                >
                  <BiPlus size={20} />

                  {isSubmitting ? (
                    <Spinner className="w-4 h-4" />
                  ) : (
                    "Update cash limit"
                  )}
                </Button>
              </div>
            </form>
          </>
        }
      />

      <CustomModal
        title="Cash balance funding list"
        onClose={() => setMoreModal(false)}
        open={showmoreModal}
        children={
          <>
            <table className="bg-white w-full table-auto text-center">
              <thead>
                <tr>
                  {[
                    "No",
                    "Insurance Company Name",
                    "Funded Amount",
                    "Cash Limit",
                    "Date Funded",
                    "Action",
                  ].map((head) => (
                    <th
                      key={head}
                      className="border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                    >
                      <Typography
                        color="black"
                        className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {companyRolePermissions.length > 0 ? (
                  companyRolePermissions.map((item: any, index: number) => {
                    const isLast = index === companyRolePermissions.length - 1
                    const classes = isLast
                      ? "px-4 py-2 text-center"
                      : "px-4 py-2 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        key={index.toString()}
                        className="hover:bg-gray-100 transition-all even:bg-gray-200"
                      >
                        <td className={classes}>
                          <Typography
                            variant="small"
                            className="font-normal text-xs capitalize"
                          >
                            {index + 1}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            className="font-normal text-xs capitalize"
                          >
                            {item.insurer_company.name}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            className="font-normal text-xs capitalize"
                          >
                            GHC{" "}
                            {item.amount.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            className="font-normal text-xs capitalize"
                          >
                            GHC{" "}
                            {item.cash_limit.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item.datecreated).format("LLL")}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Tooltip content="Delete">
                            <IconButton
                              onClick={() =>
                                removeBalance(
                                  item?.user_id,
                                  item?.usertype,
                                  item?.funded_by_company,
                                  item?.amount
                                )
                              }
                              size="sm"
                              color="red"
                              className="w-full flex items-center justify-center text-xs font-normal capitalize"
                            >
                              <BiTrash />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={5} className="px-4 py-2 text-center">
                      <Typography
                        variant="small"
                        className="font-normal text-xs capitalize"
                      >
                        No records found.
                      </Typography>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        }
      />

      <div className="w-full rounded-lg lg:col-span-2 overflow-hidden">
        <div
          style={{
            color:
              colors?.length! > 1
                ? `${colors![0]?.toLowerCase()}`
                : `${DEFAULTPRIMARYCOLOR}`,
          }}
          className="bg-black p-3 "
        >
          <Typography className="text-lg">
            List of All Account Funding Requests
          </Typography>
        </div>
        <div className="p-3 bg-white rounded-b-xl">
          <CardBody className="shadow-none overflow-x-scroll px-0 py-0  rounded-none">
            <div className="p-3">
              <div className="w-full mr-3">
                <Input
                  crossOrigin="anonymous"
                  label="Search"
                  value={searchRequestText}
                  onChange={handleSearch}
                  icon={<i className="fas fa-search text-base"></i>}
                />
              </div>
            </div>
            <table className=" bg-white w-full min-w-max table-auto text-center">
              <thead className="">
                <tr>
                  {[
                    "no",
                    "Account",
                    "Previous Balance",
                    "Funding Amount",
                    "Account Limit",
                    "Date Requested",
                    "",
                  ].map((head) => (
                    <th
                      key={head}
                      className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                    >
                      <Typography
                        color="black"
                        className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedFundsData?.map((item, index: number) => {
                  const isLast = index === paginatedFundsData?.length - 1
                  const classes = isLast
                    ? "px-4 py-2  text-center"
                    : "px-4 py-2 border-b-2 border-blue-gray-50 text-center"

                  return (
                    <tr
                      key={index.toString()}
                      className="hover:bg-gray-100 transition-all even:bg-gray-200"
                    >
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {index + 1}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {item?.parameter_type === parameter_type.agent_id
                            ? item?.agent
                            : item?.parameter_type === parameter_type?.broker_id
                            ? item?.broker_name
                            : item?.parameter_type === parameter_type.staff_id
                            ? item?.company_staff_name
                            : item?.parameter_type === parameter_type?.branch_id
                            ? item?.branch_name
                            : item?.parameter_type ===
                              parameter_type?.division_id
                            ? item?.division_name
                            : item?.company_role_name}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          GHS{" "}
                          {item?.parameter_type === parameter_type.agent_id
                            ? (0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : item?.parameter_type === parameter_type.broker_id
                            ? (0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : (0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          GHS{" "}
                          {item?.amount}
                          {/* {parseInt(item?.amount ?? "0").toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )} */}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          GHS{" "}
                          {item?.parameter_type === parameter_type.agent_id
                            ? (
                                parseInt(item?.agent_cash_limit!) || 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : item?.parameter_type === parameter_type.broker_id
                            ? (
                                parseInt(item?.broker_cash_limit!) || 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : (
                                parseInt(item?.staff_cash_limit!) || 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}                          
      
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {moment(item?.created_at).format("LLL")}
                        </Typography>
                      </td>

                      {/* <td className={classes}>
                        <div className="w-full flex flex-row items-center gap-x-2">
                          <Button
                            onClick={() => {
                              Setaction("approve")
                              setSelectedItem(item)
                              setOpenOtp(true)
                            }}
                            size="sm"
                            color="green"
                            className="w-full flex items-center justify-center text-xs font-normal capitalize"
                          >
                            {action === "approve" && submitting
                              ? "loading..."
                              : "Approve"}
                          </Button>
                          <Button
                            onClick={() => {
                              Setaction("disapprove")
                              setSelectedItem(item)
                              setOpenOtp(true)
                            }}
                            size="sm"
                            color="red"
                            className="w-full flex items-center justify-center text-xs font-normal capitalize"
                          >
                            {action === "disapprove" && submitting
                              ? "loading..."
                              : "disapprove"}
                          </Button>
                          <Button
                            onClick={() =>
                              onUpdateClick(
                                item?.parameter_type!,
                                item?.parameter_id!,
                                item?.funded_company_id!
                              )
                            }
                            size="sm"
                            color="green"
                            className="w-full flex items-center justify-center text-[14px] font-normal capitalize"
                          >
                            Update cash limit
                          </Button>
                        </div>
                      </td> */}

                      <td className={classes}>
                        <div className="w-full flex flex-row items-center gap-x-2">
                          <select
                            className="w-full p-2 text-xs font-normal bg-blue-400 text-white capitalize border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e) => {
                              const selectedAction = e.target.value;
                              switch (selectedAction) {
                                case "approve":
                                  Setaction("approve");
                                  setSelectedItem(item);
                                  setOpenOtp(true);
                                  break;
                                case "disapprove":
                                  Setaction("disapprove");
                                  setSelectedItem(item);
                                  setOpenOtp(true);
                                  break;
                                case "edit_cash_limit":
                                  const cashLimit =
                                    parseInt(
                                      item?.agent_cash_limit ??
                                      item?.broker_cash_limit ??
                                      item?.staff_cash_limit
                                    );
                              
                                  onUpdateClick(
                                    item?.parameter_type!,
                                    item?.parameter_id!,
                                    item?.funded_company_id!,
                                    cashLimit
                                    
                                  );
                                  break;

                              }
                            }}
                          >
                            <option value="" disabled selected>
                              Select Action
                            </option>
                            <option value="approve">Approve</option>
                            <option value="disapprove">Disapprove</option>
                            <option value="edit_cash_limit">Edit Cash Limit</option>

                          </select>
                        </div>
                      </td>

                    </tr>
                  )
                })}
              </tbody>
            </table>
          </CardBody>

          {loadingFunds && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {!paginatedFundsData && !loadingFunds && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="black" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedFundsData?.length! === 0 && !loadingFunds && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="black" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedFundsData &&
            paginatedFundsData?.length !== 0 &&
            !loadingFunds && (
              // <GeneralPagination
              //   color="black"
              //   totalItems={totalFundItems?.length!}
              //   itemsPerPage={itemsPerPage}
              //   currentPage={currentPageBa}
              //   onPageChange={handlePageChangeFa}
              // />

              <WhitePaginateComponent
                totalPages={totalFundItems?.length!}
                currentPage={currentPageFa}
                setCurrentPage={setCurrentPageFa}
                perPage={itemsPerPage}
              />
            )}
          {/* {paginatedFundsData && (
            <div className="my-10 flex items-center justify-center">
              <div className="flex items-center gap-8">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prevPage}
                  disabled={activePage === 1}
                >
                  <AiOutlineArrowLeft strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <Typography color="gray" className="font-normal">
                  Page <strong className="text-gray-900">{activePage}</strong>{" "}
                  of{" "}
                  <strong className="text-gray-900">
                    {Math.ceil(
                      (funds?.view_fund_account_details?.filter(filterData)
                        .length || 0) / PAGE_SIZE
                    )}
                  </strong>
                </Typography>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={nextPageFunding}
                  disabled={
                    activePage ===
                    Math.ceil(
                      (funds?.view_fund_account_details?.filter(filterData)
                        .length || 0) / PAGE_SIZE
                    )
                  }
                >
                  <AiOutlineArrowRight strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
          )} */}
        </div>
      </div>

      <div className="w-full rounded-lg lg:col-span-2 overflow-hidden mt-10">
        <div
          style={{
            color:
              colors?.length! > 1
                ? `${colors![0]?.toLowerCase()}`
                : `${DEFAULTPRIMARYCOLOR}`,
          }}
          className="bg-black p-3 "
        >
          <Typography className="text-lg">Account balances</Typography>
        </div>
        <div className="p-3 bg-white rounded-b-xl">
          <CardBody className="shadow-none overflow-x-scroll px-0 py-0  rounded-none">
            <div className="p-3">
              <div className="w-full mr-3">
                <Input
                  crossOrigin="anonymous"
                  label="Search"
                  value={searchBalanceText}
                  onChange={handleBalanceSearch}
                  icon={<i className="fas fa-search text-base"></i>}
                />
              </div>
            </div>
            <table className=" bg-white w-full min-w-max table-auto text-center">
              <thead className="">
                <tr>
                  {["no", "Account", "Balance", "Account Type", ""].map(
                    (head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedBalanceData?.map((item, index: number) => {
                  const isLast = index === paginatedBalanceData?.length - 1
                  const classes = isLast
                    ? "px-4 py-2  text-center"
                    : "px-4 py-2 border-b-2 border-blue-gray-50 text-center"

                  return (
                    <tr
                      key={index.toString()}
                      className="hover:bg-gray-100 transition-all even:bg-gray-200"
                    >
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {index + 1}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {item?.name}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          GHC{" "}
                          {item?.balance?.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {item?.record_type === "sub_agent"
                            ? "Agent"
                            : item?.record_type === "company_staff"
                            ? "Staff"
                            : item?.record_type === "broker"
                            ? "Broker"
                            : ""}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Tooltip content="Delete">
                          <IconButton
                            onClick={() =>
                              removeBalance(
                                item?.record_id,
                                item?.record_type,
                                item?.balance,
                                item?.funded_by
                              )
                            }
                            size="sm"
                            color="red"
                            className="w-full flex items-center justify-center text-xs font-normal capitalize"
                          >
                            <BiTrash />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </CardBody>

          {loadingBalances && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {!paginatedBalanceData && !loadingBalances && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="black" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedBalanceData?.length! === 0 && !loadingBalances && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="black" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedBalanceData &&
            paginatedBalanceData?.length !== 0 &&
            !loadingBalances && (
              // <GeneralPagination
              //   color="black"
              //   totalItems={totalBallanceItems?.length!}
              //   itemsPerPage={itemsPerPage}
              //   currentPage={currentPageBa}
              //   onPageChange={handlePageChangeBa}
              // />

              <WhitePaginateComponent
                totalPages={totalBallanceItems?.length!}
                currentPage={currentPageBa}
                setCurrentPage={setCurrentPageBa}
                perPage={itemsPerPage}
              />
            )}
          {/* {paginatedBalanceData && (
            <div className="my-10 flex items-center justify-center">
              <div className="flex items-center gap-8">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prevPage}
                  disabled={activePage2 === 1}
                >
                  <AiOutlineArrowLeft strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <Typography color="gray" className="font-normal">
                  Page <strong className="text-gray-900">{activePage2}</strong>{" "}
                  of{" "}
                  <strong className="text-gray-900">
                    {Math.ceil(
                      (balances?.positive_balance_view?.filter(filterBalance)
                        .length || 0) / PAGE_SIZE
                    )}
                  </strong>
                </Typography>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={nextPage}
                  disabled={
                    activePage2 ===
                    Math.ceil(
                      (balances?.positive_balance_view?.filter(filterBalance)
                        .length || 0) / PAGE_SIZE
                    )
                  }
                >
                  <AiOutlineArrowRight strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
          )} */}
        </div>
      </div>

      <div className="h-20" />
    </>
  )
}

export default FundingApproval
